import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import {
  GlobalMessageService,
  GlobalMessageType,
  RoutingService,
  TranslationService
} from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import {
  DeliveryNote,
  DeliveryNoteItem,
  DeliveryNoteDetailsSortOptions
} from '../../delivery-notes.models';
import { DeliveryNotesService } from '../../delivery-notes.service';
import {
   getDeliveryNote
} from '../../store/delivery-notes.actions';
import {
  selectDeliveryNote,
  loadingDeliveryNote,
  errorDeliveryNote
} from '../../store/delivery-notes.selectors';

@Component({
    selector: 'app-delivery-notes-detail',
    templateUrl: './delivery-notes-detail.component.html',
    styleUrls: [
        './delivery-notes-detail.component.scss',
        './delivery-notes-detail-print.component.scss',
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DeliveryNotesDetailComponent implements OnInit {

  deliveryNumber: string;
  deliveryNote$: Observable<DeliveryNote> = this.store.select(selectDeliveryNote);
  deliveryNote: DeliveryNote;
  entries: DeliveryNoteItem[];
  isLoadingDeliveryNote$: Observable<boolean> = this.store.select(loadingDeliveryNote);
  errorDeliveryNote$: Observable<Error> = this.store.select(errorDeliveryNote);

  isUpdateMode: boolean = false;
  selectedSortOption: string;
  sortOptions: string[];
  sortDirection: string = 'asc';
  compare = (v1: string | number | Date, v2: string | number | Date) =>
    v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

  lastSegment: number;

  constructor(
    private route: ActivatedRoute,
    private routing: RoutingService,
    private translation: TranslationService,
    private messageService: GlobalMessageService,
    private modalService: NgbModal,
    private deliveryNotesService: DeliveryNotesService,
    private store: Store<{ deliveryNote: DeliveryNote }>
  ) {}

  ngOnInit(): void {
    this.setSortOptions();
    this.deliveryNumber =  this.route.snapshot.url[this.route.snapshot.url.length-1].toString();

    this.fetchDeliveryNote();
    this.deliveryNote$
      .pipe(
        filter((deliveryNote) => deliveryNote != null),
        tap((deliveryNote) => {
          this.deliveryNote = deliveryNote;
          this.entries = deliveryNote.entries;
          this.onChangeSort();
        })
      )
      .subscribe();
    this.errorDeliveryNote$
      .pipe(
        filter((error) => error != null),
        switchMap(() => this.translation.translate('deliveryNotes.errorDeliveryNote')),
        tap((text) => {
          this.messageService.add(text, GlobalMessageType.MSG_TYPE_ERROR);
        })
      )
      .subscribe();
    this.fetchDeliveryNote();
  }

  setSortOptions() {
    this.selectedSortOption =
      DeliveryNoteDetailsSortOptions[
        DeliveryNoteDetailsSortOptions.position
      ];
    this.sortOptions = Object.values(
      DeliveryNoteDetailsSortOptions
    ).filter((value) => typeof value === 'string') as string[];
  }

  onChangeSort() {
    this.deliveryNote = { ...this.deliveryNote };
    this.entries = [...this.deliveryNote.entries].sort((a, b) => {
      const res = this.compare(
        a[this.selectedSortOption],
        b[this.selectedSortOption]
      );
      return this.sortDirection === 'asc' ? res : -res;
    });
    this.deliveryNote.entries = this.entries;
  }

  onSubmit(updatePosition: number) {
    var count = this.deliveryNote.entries.length;
    var entries = new Array();
    for (let i = 0; i < count; i++) {
      let position = this.deliveryNote.entries[i].position;
     }
  }

  onUpdateMode() {
    this.isUpdateMode = true;
  }

  onExport() {
    this.deliveryNotesService.printOrExportDeliveryNote(this.deliveryNumber, false);
  }

  fetchDeliveryNote(): void {
    this.isUpdateMode = false;
    this.store.dispatch(
      getDeliveryNote({
        uigDeliveryNumber: this.deliveryNumber,
      })
    );
  }

  goToDeliveryNotesOverview(): void {
    this.routing.go({
      cxRoute: 'deliveryNotes',
    });
  }
}
